import React from 'react';
import ScrollEffectWrapper from './ScrollEffectWrapper';
import ExperienceCard from './ExperienceCard';
import workExperience from '../data/workExperience';

function ExperienceSection() {
  return (
    <section className="section experience-section">
      <div className="container">
        <ScrollEffectWrapper animationType="title">
          <div className="section-header">
            <h2 className="section-title">Professional Experience</h2>
            <p className="section-subtitle">My career journey and achievements</p>
          </div>
        </ScrollEffectWrapper>

        <div className="experience-timeline">
          {workExperience.map((exp, index) => (
            <ScrollEffectWrapper key={exp.company} animationType="slide-up" delay={index * 150}>
              <ExperienceCard experience={exp} />
            </ScrollEffectWrapper>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ExperienceSection;
